import React, { useMemo } from 'react';
import { ReactTable } from 'components/shared/ReactTable';
import { getTableData } from '../../utils';
import SectorKPIsTableHead from './SectorKPIsTableHead';
import SectorKPIsTableBody from './SectorKPIsTableBody';
import SectorKPIsTableHeading from './SectorKPIsTableHeading';
import styles from './SectorKPIsTable.module.css';

const columns = [
  {
    accessor: 'displayName',
    Header: 'Metric',
    className: styles.cell
  },
  {
    accessor: 'downlink.vpol',
    Header: 'Downlink - VPol',
    className: styles.cell
  },
  {
    accessor: 'downlink.hpol',
    Header: 'Downlink - HPol',
    className: styles.cell
  },
  {
    accessor: 'uplink.vpol',
    Header: 'Uplink - VPol',
    className: styles.cell
  },
  {
    accessor: 'uplink.hpol',
    Header: 'Uplink - HPol',
    className: styles.cell
  }
];

const rows = [
  {
    name: 'system-gain-db',
    displayName: 'System Gain (dB)',
    hidden: true
  },
  {
    name: 'max-system-gain-db',
    displayName: 'Maximum System Gain (dB)',
    hidden: true
  },
  {
    name: 'min-system-gain-db',
    displayName: 'Minimum System Gain (dB)',
    hidden: true
  },
  {
    name: 'electronic-gain-db',
    displayName: 'Electronic Gain (dB)'
  },
  {
    name: 'antenna-gain-db',
    displayName: 'Antenna Gain (dB)',
    hidden: true
  },
  {
    name: 'rx-gain-db',
    displayName: 'Rx Gain (dB)'
  },
  {
    name: 'tx-gain-db',
    displayName: 'Tx Gain (dB)'
  },
  {
    name: 'rx-if-pwr-dbm',
    displayName: 'Rx IF Power (dBm)'
  },
  {
    name: 'tx-if-pwr-dbm',
    displayName: 'Tx IF Power (dBm)'
  },
  {
    name: 'tx-rf-pwr-dbm',
    displayName: 'Tx RF Power (dBm)'
  },
  {
    name: 'tx-eirp-dbm',
    displayName: 'Tx EIRP (dBm)',
    hidden: true
  },
  {
    name: 'rx-pwr-indicator-dbm',
    displayName: 'Rx Power Indicator (dBm)',
    hidden: true
  }
];

function SectorKPIsTable({ info }) {
  const data = useMemo(() => getTableData(columns, rows, info), [info]);

  return (
    <ReactTable
      className={styles.root}
      data={data}
      columns={columns}
      resizable={false}
      showPagination={false}
      pageSize={data.length}
      TheadComponent={SectorKPIsTableHead}
      TbodyComponent={SectorKPIsTableBody}
      ThComponent={SectorKPIsTableHeading}
    />
  );
}

export default SectorKPIsTable;
